module.exports = __webpack_public_path__ + "static/media/undraw_walk_in_the_city_1ma6.ff757fcd.svg";